import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "statutes",
  courseId: "writing-and-editing",
  order: 3,
  title: "Statutes panel",
  summary:
    "See which charges your narrative supports, ranked by how well the facts match. If your agency has uploaded its code, department sections are included.",
  learn: [
    "Set your statute state so the panel works",
    "Run Identify Statutes and read the match strength",
    "Tell a state statute from a department code section",
  ],
  minutes: 3,
  sceneId: "statutes",
  tourId: "statutes",
  releasedAt: "2025-06-01T00:00:00.000Z",
  body: [
    {
      type: "paragraph",
      text: "The **Statutes** tab reads the narrative and lists the sections the facts support. Treat it as a prompt for your own judgment, not a charging decision.",
    },
    { type: "heading", text: "Set your state first" },
    {
      type: "steps",
      items: [
        "If the button reads **Set Statutes State**, click it.",
        "In **Report Preferences**, set **Include Statutes** to your state.",
        "Click **Save Preferences**.",
      ],
    },
    { type: "heading", text: "Identify statutes" },
    {
      type: "steps",
      items: [
        "Back in the case, open **Statutes** and click **Identify Statutes**.",
        "Read the tag on each result: Strong Match, Match, or Weak Match.",
        "Click **More Info** on a state statute to search the web for its text.",
        "For a result with a Dept badge, click **Open section** to read the source page.",
      ],
    },
    {
      type: "paragraph",
      text: "A Dept badge means the result comes from your department's own documents, such as municipal code or directives.",
    },
    {
      type: "callout",
      tone: "note",
      title: "Department first, state second",
      text: "When your agency has uploaded code documents, a department section that fits a violation is listed first and cited in the narrative instead of the state statute. State law is the fallback.",
    },
    {
      type: "callout",
      tone: "tip",
      title: "Weak matches",
      text: "A weak match usually means an element is missing from the narrative, not that the charge is wrong. Check the suggestions list, where the missing element is often already waiting.",
    },
  ],
  related: ["search-and-ask", "report-preferences-in-depth", "review-the-draft"],
};

export default lesson;
